import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Injectable({
  providedIn: 'root',
})
export class HttpServiceBundle {

  constructor(public httpClient: HttpClient, public dialog: MatDialog) { }
}
